"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const DisabledEDS = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)("h2", { children: "Sorry this module is currently disabled." }) }));
};
exports.default = DisabledEDS;
